import { Injectable } from '@angular/core';
import {
  ROMEXIS_LEGACY_MODE_MAP,
  RomexisCaptureMode,
  RomexisLegacyCaptureMode,
  RomexisOpenPatientCommand,
  RomexisToDeviceCommand,
} from '@principle-theorem/principle-bridge-core';
import {
  IBridgeDevice,
  IPatient,
  RomexisBridgeConfiguration,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { get } from 'lodash';
import { BridgeCommandsService } from '../../../bridge-commands.service';

@Injectable()
export class RomexisFeatureService {
  constructor(private _bridgeCommands: BridgeCommandsService) {}

  async openPatient(
    patient: WithRef<IPatient>,
    mode: RomexisCaptureMode,
    device: WithRef<IBridgeDevice>
  ): Promise<void> {
    const config =
      device.settings?.romexis?.configuration ?? RomexisBridgeConfiguration.V5;

    const command: RomexisOpenPatientCommand = {
      type: RomexisToDeviceCommand.OpenRomexis,
      data: {
        patient,
        config,
        mode: this._getRomexisMode(config, mode),
      },
    };
    await this._bridgeCommands.sendCommand(command, device.ref);
  }

  private _getRomexisMode(
    config: RomexisBridgeConfiguration,
    mode: RomexisCaptureMode
  ): RomexisCaptureMode | RomexisLegacyCaptureMode {
    return config === RomexisBridgeConfiguration.V5
      ? mode
      : get(ROMEXIS_LEGACY_MODE_MAP, mode, RomexisLegacyCaptureMode.None);
  }
}
